import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import taskService from '../../services/taskService';
import './TaskList.css';
import IssueStore from '../Issues/IssueStore';
import CommonModal from '../../services/CommonModal';
import TaskStore from './TaskStore';
import milestoneService from '../../services/milestoneService';
import projectService from '../../services/projectService';
import Select from "react-select";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import { customDateFormatShort } from '../../config/utils';


const TaskList = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const { setSelectedCopyTask, clearSelectedCopyTask } = TaskStore();
  const [projects, setProjects] = useState([]);
  const [milestones, setMilestones] = useState([]);
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({});
  const { selectedIssue, setSelectedIssue, clearSelectedIssue } = IssueStore();
  const [showStatus, setShowStatus] = useState(false);
  const [showAssignees, setShowAssignees] = useState(false);
  const { user } = useAuth();
  const dropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowAssignees(false);
      }

      if (
        statusDropdownRef.current &&
        !statusDropdownRef.current.contains(event.target)
      ) {
        setShowStatus(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const statusOptions = [
    { value: "All", label: "All status" },
    { value: "To Do", label: "To Do" },
    { value: "In Progress", label: "In Progress" },
    { value: "In Review", label: "In Review" },
    { value: "Done", label: "Done" },
    { value: "Blocked", label: "Blocked" },
  ];

  const setCopySelectedTask = TaskStore(
    (state) => state.setCopySelectedTask
  );

  const isAdmin = user?.role?.name === "Admin";


  const [filters, setFilters] = useState({
    status: ['To Do'],
    assigned_to: isAdmin ? [] : [`${user.id}`],
    priority: '',
    search: '',
    page: 1,
    limit: 20
  });

  const confirmDelete = () => {
    console.log("uuuu")
    handleDelete(selectedTask.id);
    setShowDeleteModal(false);
  };

  const fetchMilestones = async () => {
    try {
      const data = await milestoneService.getAllMilestones();
      setMilestones(data.data || []);
    } catch (err) {
      console.error('Failed to fetch milestones:', err);
    }
  };
  const fetchProjects = async () => {
    try {
      const data = await projectService.getAllProjects();
      setProjects(data.projects || []);
    } catch (err) {
      console.error('Failed to fetch projects:', err);
    }
  };
  const loadUsers = async () => {
    try {
      const data = await taskService.getAll();
      console.log("users", data)
      setUsers(data.users || []);
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };
  useEffect(() => {
    fetchTasks();
    fetchProjects();
    // fetchMilestones();
    loadUsers();
  }, [filters]);
  const navigate = useNavigate();

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const data = await taskService.getAllTasks(filters);
      setTasks(data.tasks || []);
      setPagination(data.pagination || {});
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch tasks');
      setTasks([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await taskService.deleteTask(id);
      fetchTasks();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to delete task');
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value, page: 1 }));
  };
  const realStatuses = statusOptions
    .filter((s) => s.value !== "All")
    .map((s) => s.value);

  const handleStatusChange = (status) => {
    setFilters((prev) => {
      if (status === "All") {
        const isAllSelected = realStatuses.every((s) => prev.status.includes(s));
        return { ...prev, status: isAllSelected ? [] : realStatuses };
      }

      const updated = prev.status.includes(status)
        ? prev.status.filter((s) => s !== status)
        : [...prev.status, status];

      return { ...prev, status: updated };
    });
    setShowStatus(false);
  };

  const handleAssigneeChange = (userId) => {
    setFilters((prev) => ({
      ...prev,
      assigned_to: prev.assigned_to.includes(userId)
        ? prev.assigned_to.filter((id) => id !== userId)
        : [...prev.assigned_to, userId],
    }));

    setShowAssignees(false); // Remove this line if you don't want it to close after each selection.
  };

  const handleAllAssignees = () => {
    if (filters.assigned_to.length === users.length) {
      // Uncheck all
      setFilters((prev) => ({
        ...prev,
        assigned_to: [],
      }));
    } else {
      // Select all users
      setFilters((prev) => ({
        ...prev,
        assigned_to: users.map((user) => user.id),
      }));
    }
  };


  const getStatusBadge = (status) => {
    const statusColors = {
      'To Do': 'badge-secondary',
      'In Progress': 'badge-primary',
      'In Review': 'badge-warning',
      'Done': 'badge-success',
      'Blocked': 'badge-danger'
    };
    return statusColors[status] || 'badge-secondary';
  };

  const getPriorityBadge = (priority) => {
    const priorityColors = {
      'Low': 'badge-info',
      'Medium': 'badge-warning',
      'High': 'badge-danger',
      'Critical': 'badge-danger-dark'
    };
    return priorityColors[priority] || 'badge-secondary';
  };

  if (loading && tasks.length === 0) {
    return <div className="loading">Loading tasks...</div>;
  }

  const handleTaskClick = (id, isEdit) => {
    clearSelectedIssue()
    navigate(`/app/tasks/${id}`);
    console.log("iddd", id, isEdit)
  };


  const handleTaskEdit = (id) => {
    clearSelectedIssue()
    navigate(`/app/tasks/${id}/edit`);
    console.log("iddd", id)
  };

  const handleTaskCopy = (task) => {
    setCopySelectedTask(task);
    console.log("Copied task:", task);
    navigate("/app/tasks/new");
  };

  const downloadFileFromUrl = (fileUrl, fileName) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const downloadTaskAsJson = (task) => {
    const dataStr = JSON.stringify(task, null, 2);
    const blob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `task-${task.task_code || task.id}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleTaskDownload = async (task) => {
    try {
      const attachments = task.attachments || [];

      if (attachments.length === 0) {
        toast.error('No data found');
        return;
      }

      for (const attachment of attachments) {
        const fileName = attachment.file_name || `attachment-${attachment.id}`;
        try {
          downloadFileFromUrl(attachment.attachment_url, fileName);
        } catch (fileErr) {
          console.error(`Failed to download attachment ${fileName}:`, fileErr);
          alert(`Failed to download attachment: ${fileName}`);
        }
      }
    } catch (err) {
      console.error('Failed to download task:', err);
      alert('Failed to download task');
    }
  };


  const goToView = (task) => {
    setCopySelectedTask(task);
    console.log("Copied task:", task);
    navigate("/app/tasks/:id");
  };

  const handleTaskCreate = () => {
    setCopySelectedTask(null);
    navigate(`/app/tasks/new`);
  };;

  const selectedUsers = users.filter((user) =>
    filters.assigned_to.includes(user.id)
  );


  const handleProjectChange = async (e) => {
    const value = e.target.value;

    console.log("appii",)

    try {
      const data = await projectService.getProjectMilestones(value);
      setMilestones(data.milestones || []);

      console.log("milestons", data)
    } catch (error) {
      toast.error("Milestones not found")
      console.error("API Error:", error);
    }
  };

  return (
    <div className="task-list-container">
      <div className="task-list-header">
        <h1>Tasks</h1>
        <button onClick={() => handleTaskCreate()} className="btn btn-primary">
          <i className="fas fa-plus"></i> Create Task
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      <CommonModal
        isOpen={showDeleteModal}
        title="Delete Task"
        message="Are you sure you want to delete this task?"
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedTask(null);
        }}
        onConfirm={confirmDelete}
        type="error"
        confirmText="Delete"
        cancelText="Cancel"
      />

      <div className="grid grid-cols-1 gap-4 mb-6 md:grid-cols-2 xl:grid-cols-6 ">

        {/* Project */}
        <select
          name="project_id"
          value={filters.project_id}
          onChange={handleProjectChange}
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
        >
          <option value="">All Projects</option>
          {projects.map((project) => (
            <option key={project.id} value={project.id}>
              {project.name}
            </option>
          ))}
        </select>

        {/* Milestone */}
        <select
          name="milestone_id"
          value={filters.milestone_id}
          onChange={handleFilterChange}
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
        >
          <option value="">All Milestones</option>
          {milestones.map(milestone => (
            <option key={milestone.id} value={milestone.id}>
              {milestone.name} {milestone.project && ``}  {customDateFormatShort(milestone.due_date)} to {customDateFormatShort(milestone.completion_date)}  {milestone.status === 'In Progress' && '- Current'}
            </option>
          ))}
        </select>

        {/* Assignees */}
        <div className="relative" ref={dropdownRef}>
          <button
            type="button"
            onClick={() => setShowAssignees((prev) => !prev)}
            className="flex w-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
          >
            <span className="truncate">
              {filters.assigned_to.length === users.length
                ? "All Assignees"
                : filters.assigned_to.length === 0
                  ? "All"
                  : `${selectedUsers[0]?.first_name} ${selectedUsers[0]?.last_name}${selectedUsers.length > 1 ? ` +${selectedUsers.length - 1}` : ""
                  }`}
            </span>

            {showAssignees ? <FaChevronUp /> : <FaChevronDown />}
          </button>

          {showAssignees && (
            <div className="absolute left-0 right-0 z-50 mt-2 max-h-64 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">
              <label className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100">
                <input
                  type="checkbox"
                  checked={filters.assigned_to.length === users.length && users.length > 0}
                  onChange={handleAllAssignees}
                />
                All Assignees
              </label>

              <hr />

              {users.map((user) => (
                <label
                  key={user.id}
                  className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100"
                >
                  <input
                    type="checkbox"
                    checked={filters.assigned_to.includes(user.id)}
                    onChange={() => handleAssigneeChange(user.id)}
                  />
                  {user.first_name} {user.last_name}
                </label>
              ))}
            </div>
          )}
        </div>

        {/* Status */}
        <div className="relative" ref={statusDropdownRef}>
          <button
            type="button"
            onClick={() => setShowStatus((prev) => !prev)}
            className="flex w-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
          >
            <span className="truncate">
              {filters.status.length
                ? filters.status.join(", ")
                : "All Status"}
            </span>

            {showStatus ? <FaChevronUp /> : <FaChevronDown />}
          </button>

          {showStatus && (
            <div className="absolute left-0 right-0 z-50 mt-2 max-h-64 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">
              {statusOptions.map((status) => (
                <label key={status.value} className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100">
                  <input
                    type="checkbox"
                    checked={
                      status.value === "All"
                        ? realStatuses.every((s) => filters.status.includes(s))
                        : filters.status.includes(status.value)
                    }
                    onChange={() => handleStatusChange(status.value)}
                  />
                  {status.label}
                </label>
              ))}
            </div>
          )}
        </div>

        {/* Priority */}
        <select
          name="priority"
          value={filters.priority}
          onChange={handleFilterChange}
          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
        >
          <option value="">All Priority</option>
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
          <option value="Critical">Critical</option>
        </select>

        {/* Search */}
        <input
          type="text"
          name="search"
          placeholder="Search tasks..."
          value={filters.search}
          onChange={handleFilterChange}
          className="w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
        />

      </div>

      <div className="task-list">
        {!tasks || tasks.length === 0 ? (
          <div className="no-tasks">
            <p>No tasks found</p>
            <Link to="/app/tasks/new" className="btn btn-primary">Create your first task</Link>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Title</th>
                  <th>Type</th>
                  {/* <th>Project</th> */}
                  <th>Milestone</th>
                  <th>Parent Task</th>
                  <th>Assignee</th>
                  <th>Hours</th>
                  <th>Status</th>
                  <th>Priority</th>
                  <th>Due Date</th>
                  <th>Created By</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map(task => (
                  <tr key={task.id}>

                    <td>
                      <span
                        className="text-info cursor-pointer"
                        onClick={() => handleTaskClick(task.id, false)}
                      >
                        {task.task_code}
                      </span>
                    </td>
                    <td>
                      <span
                        className="task-info cursor-pointer"
                        onClick={() => handleTaskClick(task.id, false)}
                      >
                        {task.title}
                      </span>
                    </td>

                    <td>
                      <span className="badge badge-secondary">
                        {task.task_type || 'Task'}
                      </span>
                    </td>
                    {/* <td>
                      {task.project ? (
                        <Link to={`/app/projects/${task.project.id}`}>
                          {task.project.name}
                        </Link>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td> */}
                    <td>
                      {task.milestone ? (
                        <span className="text-info">
                          {task.milestone.name || task.milestone_id}
                        </span>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                    <td>
                      {task.parent_task ? (
                        <Link to={`/app/tasks/${task.parent_task.id}`} className="text-primary">
                          {task.parent_task.title || task.parent_task_id}
                        </Link>
                      ) : task.parent_task_id ? (
                        <span className="text-muted">{task.parent_task_id}</span>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                    <td>
                      {task.assignee ? (
                        <span>
                          {task.assignee.first_name} {task.assignee.last_name}
                        </span>
                      ) : (
                        <span className="text-muted">Unassigned</span>
                      )}
                    </td>
                    <td>

                      <span>
                        {(task.actual_hours != null && task.actual_hours != '0.00') ? task.actual_hours : 0} / {(task.estimated_hours != null && task.estimated_hours != '0.00') ? task.estimated_hours : 0}
                      </span>

                    </td>
                    <td>
                      <span className={`badge ${getStatusBadge(task.status)}`}>
                        {task.status}
                      </span>
                    </td>
                    <td>
                      <span className={`badge ${getPriorityBadge(task.priority)}`}>
                        {task.priority}
                      </span>
                    </td>
                    <td>
                      {task.due_date ? (
                        customDateFormatShort(task.due_date)
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                    <td>
                      {task.reporter ? (
                        <span>
                          {task.reporter.first_name} {task.reporter.last_name}
                        </span>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                    <td>
                      <div className="action-buttons">
                        {/* <Link
                          to={`/app/tasks/${task.id}/edit`}
                          className="btn btn-sm btn-outline-primary custom-pbtn"
                          title="Edit"
                        >
                          <i className="fas fa-edit"></i>
                        </Link> */}
                        <button
                          onClick={() => handleTaskEdit(task.id)}
                          className="btn btn-sm btn-outline-primary custom-pbtn"
                          title="Edit"
                        >
                          <i className="fas fa-edit custom-fas-icon"></i>
                        </button>

                        <button
                          onClick={() => handleTaskCopy(task)}
                          className="btn btn-sm badge-info"
                          title="Copy"
                        >
                          <i className="fas fa-copy"></i>
                        </button>
                        {/* 
                        <button
                          onClick={() => handleTaskDownload(task)}
                          className="btn btn-sm btn-secondary "
                          title="Download"
                        >
                          <i className="fas fa-download"></i>
                        </button> */}

                        {/* <button
                          onClick={() => {
                            setSelectedTask(task);
                            setShowDeleteModal(true);
                          }}
                          className="btn btn-sm btn-outline-danger custom-dbtn"
                          title="Delete"
                        >
                          <i className="fas fa-trash"></i>
                        </button> */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {pagination.pages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setFilters(prev => ({ ...prev, page: prev.page - 1 }))}
            disabled={filters.page === 1}
            className="btn btn-outline-primary"
          >
            Previous
          </button>
          <span className="page-info">
            Page {pagination.page} of {pagination.pages}
          </span>
          <button
            onClick={() => setFilters(prev => ({ ...prev, page: prev.page + 1 }))}
            disabled={filters.page === pagination.pages}
            className="btn btn-outline-primary"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default TaskList;


